import ScanerBtn from './ScanerBtn';

export default ScanerBtn;
